export const NO_BROWSER_STORAGE = 'no browser storage'
export const STATE_NOT_EQUAL = 'state not equal'
export const CANT_RECOVER_CODE_VERIFIER = 'cant recover code verifier'
export const ERROR_OBTAIN_ACCESS_TOKEN = 'error obtain access token'

export const INNER_STORE: {
  authServerLoginUri: 'authServerLoginUri'
  authServerLogoutUri: 'authServerLogoutUri'
  authServerTokenUri: 'authServerTokenUri'
  authServerTokenSSOUri: 'authServerTokenSSOUri'
  client_id: 'client_id'
  redirect_uri: 'redirect_uri'
  scope: 'scope'
  withState: 'withState'
  auth: 'auth'
  additionalParams: 'additionalParams'
  autoRefresh: 'autoRefresh'
  cancelRefreshOnTime: 'cancelRefreshOnTime'
  autoRefreshTime: 'autoRefreshTime'
} = {
  authServerLoginUri: 'authServerLoginUri',
  authServerLogoutUri: 'authServerLogoutUri',
  authServerTokenUri: 'authServerTokenUri',
  authServerTokenSSOUri: 'authServerTokenSSOUri',
  client_id: 'client_id',
  redirect_uri: 'redirect_uri',
  scope: 'scope',
  withState: 'withState',
  auth: 'auth',
  additionalParams: 'additionalParams',
  autoRefresh: 'autoRefresh',
  cancelRefreshOnTime: 'cancelRefreshOnTime',
  autoRefreshTime: 'autoRefreshTime',
}

export const STORE: {
  code_verifier: 'code_verifier'
  state: 'state'
} = {
  code_verifier: 'code_verifier',
  state: 'state',
}

export const PARAMS = {
  state: 'state',
  sessionState: 'session_state',
  code: 'code',
  authorization_code: 'authorization_code',
  auth: 'auth',
}

export const EXPIREDTOKEN = 'EXPIRED-TOKEN'
export const INVALIDTOKEN = 'INVALID-TOKEN'
